import { Paper } from '@mui/material';
import { ArticleOutlined, HomeOutlined, LocalMallOutlined, PersonOutlined } from '@mui/icons-material';
import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import { createNewTheme } from './functions/utils';

import React from 'react';
import BottomNavigation from '@mui/material/BottomNavigation';
import BottomNavigationAction from '@mui/material/BottomNavigationAction';
import RestaurantMenuIcon from '@mui/icons-material/RestaurantMenu';
import Home from './pages/Home';
import Cardapio from './pages/Cardapio';
import Pedidos from './pages/Pedidos';
import Perfil from './pages/Perfil';
import axios from 'axios';
import Suspenso from './pages/Suspenso';

const AppHome = () => {

  const [colorPrimary, setColorPrimary] = useState('');
  const [colorSecondary, setColorSecondary] = useState('');
  const [colorTertiary, setColorTertiary] = useState('');
  const [value, setValue] = useState('');
  const [tipoLoja, setTipoLoja] = useState("restaurante");
  const [onlyMenu, setOnlyMenu] = useState(false);
  const [isMesa, setIsMesa] = useState(false);
  const [enableStore, setEnableStore] = useState("");
  const [usuarioSuspenso, setUsuarioSuspenso] = useState("");

  const state = useLocation().state;

  const handleConfigs = (isMesa, onlyMenu, tipoLoja, isEnabled, enable) => {
    if (isMesa) {
      setValue("cardapio");
      setIsMesa(isMesa);
    }
    if (onlyMenu) {
      setValue("cardapio");
      setOnlyMenu(true)
    }
    if (tipoLoja) {
      setTipoLoja(tipoLoja)
    }
    if (isEnabled === "ENABLED") {
      setEnableStore(enable)
    }
  };

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  useEffect(() => {
    if (state !== null) {
      if (state.page !== null) {
        setValue(state.page)
        state.page = null
      }
    }

    const onlyMenu = localStorage.getItem('eNbM') === "true";
    if (onlyMenu) {
      setOnlyMenu(onlyMenu)
    }

    const enableStore = localStorage.getItem('eNbS') === "true";
    setEnableStore(enableStore)
    const colorPrimaryC = localStorage.getItem('clPmr');
    if (!colorPrimaryC) {
      getColors()
      return
    }

    let url = localStorage.getItem('UBs');
    if (!url) {
      url = window.location.href;
      if (url.includes("localhost")) {
        url = "https://meurestaurante.mely.online/";
      }
    }
    const urlBase = new URL(url).origin;
    getActiveMenu(urlBase);
    const colorSecondaryC = localStorage.getItem('clScr');
    const colorTertiaryC = localStorage.getItem('clTcr');

    setColorPrimary(colorPrimaryC)
    setColorSecondary(colorSecondaryC)
    setColorTertiary(colorTertiaryC)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


  const getColors = () => {
    let urlBase = window.location.href;

    if (urlBase.includes("?")) {
      let arrUrl = urlBase.split("?");
      urlBase = arrUrl[0];
    }

    if (urlBase.includes("localhost")) {
      urlBase = "https://meurestaurante.mely.online";
    }

    axios.get(`${urlBase}/api/get-colors.php`, {})
      .then(response => {
        const colors = {};
        const regex = /--(\w+):\s*([^;]+);/g;

        let match;
        while ((match = regex.exec(response.data)) !== null) {
          const colorName = match[1]; // ex: "primary"
          const colorValue = match[2].trim(); // ex: "147, 15, 15"
          colors[colorName] = colorValue;
        }

        localStorage.setItem('clPmr', colors['primary']);
        localStorage.setItem('clScr', colors['secondary']);
        localStorage.setItem('clTcr', colors['tertiary']);
        setColorPrimary(colors['primary'])
        setColorSecondary(colors['secondary'])
        setColorTertiary(colors['tertiary'])
        // const arrColors = response.data.split(`\n`)
        // const colorPrimaryC = arrColors[1].replaceAll("    --primary: ", "").replaceAll(";", "")
        // const colorSecondaryC = arrColors[2].replaceAll("    --secondary: ", "").replaceAll(";", "")
        // const colorTertiaryC = arrColors[3].replaceAll("    --tertiary: ", "").replaceAll(";", "")

        // localStorage.setItem('clPmr', colorPrimaryC);
        // localStorage.setItem('clScr', colorSecondaryC);
        // localStorage.setItem('clTcr', colorTertiaryC);
        // setColorPrimary(colorPrimaryC)
        // setColorSecondary(colorSecondaryC)
        // setColorTertiary(colorTertiaryC)
      })
      .catch(error => console.error('Error:', error));

    getActiveMenu(urlBase);

  }
  //TODO VERIFICAR FUNÇÃO
  const getActiveMenu = (urlBase) => {
    console.log("Verificando se o usuário está suspenso...")
    axios.post(`https://gerenciador.mely.online/api/ativo.php`, {
      url: urlBase.replaceAll("/api", ""),
    })
      .then(response => {
        response = response.data
        if (response) {
          localStorage.setItem('iRc', response[0].ID_RCB);
          response[0].ENB_BT === "A" ? localStorage.setItem('BTMd', "A") : localStorage.setItem('BTMd', "D");

          if(response[0].CLS_EST === "1") {
            localStorage.setItem("FxEst", "1");
          } else {
            localStorage.removeItem("FxEst")
          }

          if (!response[0].ST_PG) {
            setUsuarioSuspenso(false);
            return;
          }
          const timestamp = response[0].ST_PG;
          if (!isNaN(timestamp) && Number.isInteger(Number(timestamp)) && Number(timestamp) > 0) {
            const dataTimestamp = new Date(Number(timestamp) * 1000);
            const agora = new Date();
            const timestampAgora = Date.now() / 1000;

            const diasPassados = (agora - dataTimestamp) / (1000 * 60 * 60 * 24);

            if (response[0].DT_EXP) {
              const expiracao = Number(response[0].DT_EXP) + 604800;

              if (timestampAgora >= expiracao) {
                setUsuarioSuspenso(true);
                setValue("suspenso");
              } else {
                setUsuarioSuspenso(false);
              }
            } else {
              if (diasPassados > 37) {
                console.log("Usuário suspenso por inatividade.");
                setUsuarioSuspenso(true);
                setValue("suspenso");
              } else {
                setUsuarioSuspenso(false);
              }
            }
          } else {
            setUsuarioSuspenso(true);
            setValue("suspenso");
          }
        }
      })
  }

  const handleGetTipoLoja = () => {
    switch (tipoLoja) {
      case "restaurante":
        return <>Cardápio</>
      case "loja":
        return <>Catálogo</>
      default:
        return <>Cardápio</>;
    }
  };

  const handleTipoLojaIcon = () => {
    switch (tipoLoja) {
      case "restaurante":
        return <RestaurantMenuIcon style={{ marginBottom: "6px" }} />
      case "loja":
        return <LocalMallOutlined style={{ marginBottom: "6px" }} />
      default:
        return <RestaurantMenuIcon style={{ marginBottom: "6px" }} />;
    }
  };

  const renderContent = () => {
    switch (value) {
      case 'home':
        return <Home onChange={handleChange} changeConfigs={handleConfigs} colorPrimary={colorPrimary} colorSecondary={colorSecondary} colorTertiary={colorTertiary} />;
      case 'cardapio':
        return <Cardapio onChange={handleChange} changeConfigs={handleConfigs} colorPrimary={colorPrimary} colorSecondary={colorSecondary} colorTertiary={colorTertiary} />;
      case 'pedidos':
        return <Pedidos onChange={handleChange} changeConfigs={handleConfigs} colorPrimary={colorPrimary} colorSecondary={colorSecondary} colorTertiary={colorTertiary} />;
      case 'perfil':
        return <Perfil onChange={handleChange} changeConfigs={handleConfigs} colorPrimary={colorPrimary} colorSecondary={colorSecondary} colorTertiary={colorTertiary} />;
      case 'suspenso':
        return <Suspenso onChange={handleChange} changeConfigs={handleConfigs} colorPrimary={colorPrimary} colorSecondary={colorSecondary} colorTertiary={colorTertiary} />;
      default:
        setValue("home")
        return <Home />;
    }
  };

  return (
    <ThemeProvider theme={createNewTheme(colorPrimary, colorSecondary, colorTertiary)}>
      <div>
        {/* Renderiza o conteúdo da tela selecionada */}
        {renderContent()}

        {/* Bottom Navigation */}
        {!usuarioSuspenso && enableStore && !onlyMenu && (
          <Paper style={{ position: 'fixed', bottom: 0, left: 0, right: 0 }}>
            <BottomNavigation value={value} onChange={handleChange} showLabels={true} style={{ backgroundColor: `rgba(${colorPrimary})`, height: "75px" }} >
              {!isMesa && (
                <BottomNavigationAction label="Home" value="home" icon={<HomeOutlined style={{ marginBottom: "6px" }} />} style={{
                  fontSize: "12px", fontWeight: "bold",
                  color: value === "home" ? "#FFF" : "#FFFFFFCC", borderBottom: value === "home" ? "solid #FFF 2px" : "none",
                }} />
              )}
              <BottomNavigationAction label={handleGetTipoLoja()} value="cardapio" icon={handleTipoLojaIcon()} style={{
                fontSize: "12px", fontWeight: "bold",
                color: value === "cardapio" ? "#FFF" : "#FFFFFFCC", borderBottom: value === "cardapio" ? "solid #FFF 2px" : "none",
              }} />
              {!onlyMenu && (
                <BottomNavigationAction label="Pedidos" value="pedidos" icon={<ArticleOutlined style={{ marginBottom: "6px" }} />} style={{
                  fontSize: "12px", fontWeight: "bold",
                  color: value === "pedidos" ? "#FFF" : "#FFFFFFCC", borderBottom: value === "pedidos" ? "solid #FFF 2px" : "none",
                }} />
              )}
              {!onlyMenu && !isMesa && (
                <BottomNavigationAction label="Perfil" value="perfil" icon={<PersonOutlined style={{ marginBottom: "6px" }} />} style={{
                  fontSize: "12px", fontWeight: "bold",
                  color: value === "perfil" ? "#FFF" : "#FFFFFFCC", borderBottom: value === "perfil" ? "solid #FFF 2px" : "none",
                }} />
              )}
            </BottomNavigation>
          </Paper>
        )}
      </div>
    </ThemeProvider>
  );
};

export default AppHome;
